module.exports = __webpack_public_path__ + "assets/shield.ad51d905.svg";